import { FC, useState, useEffect, useRef } from 'react';
import { useSpring, animated } from '@react-spring/web';
import styles from './Accordion.module.scss';
import Button from '../GroupActions/Button';

export interface AccordionProps {
  title: JSX.Element;
  changeTrigger: any;
}

const Accordion: FC<AccordionProps> = ({ children, title, changeTrigger }) => {
  const [height, setHeight] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHeight(containerRef.current ? containerRef.current.offsetHeight : 0);
  }, [isOpen, changeTrigger]);

  const { h } = useSpring({
    h: isOpen ? height : 0,
  });

  return (
    <div className={styles.accordion}>
      <div className={styles.accordion__title}>
        <div>{title}</div>
        <div>
          <Button theme='transparent' onClick={() => setIsOpen(!isOpen)} icon='chevron_down' />
        </div>
      </div>
      <animated.div style={{ height: h, overflow: 'hidden' }}>
        <div className={styles.accordion__item} ref={containerRef}>
          {children}
        </div>
      </animated.div>
    </div>
  );
};

export default Accordion;
